

































































import { Component, Prop, Vue } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import {
  Import as IImport,
  ImportStatusEnum
} from "@/api-v2/import-export-2/models/import";
import { ImportTypes } from "@/getinfo-api/imports2";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import { ImportSort, SortFields } from "@/plugins/sort-fields";

@Component({
  components: {
    CustomTableItem,
    CustomTableCol,
    CustomTable
  }
})
export default class ImportsTable extends Vue {
  @Prop() items!: IImport[];
  @Prop() isLoading!: boolean;
  sorted: SortFields<ImportSort> = new SortFields(ImportSort.createdAt);

  acceptSort(sort: ImportSort) {
    this.sorted.changeSort(sort);
    this.$emit("changeSort", this.sorted);
  }

  get sortStatus() {
    return ImportSort;
  }

  getStatus(status: ImportStatusEnum) {
    const result = {
      variant: "warning",
      text: `${this.$tc(this.$translate.Unknown)}`
    };

    if (status === ImportStatusEnum.Waiting) {
      result.text = `${this.$tc(this.$translate.InProcessing)}`;
      result.variant = "warning";
    }

    if (status === ImportStatusEnum.Started) {
      result.text = `${this.$tc(this.$translate.InProcessing)}`;
      result.variant = "info";
    }

    if (status === ImportStatusEnum.Success) {
      result.text = `${this.$tc(this.$translate.Success)}`;
      result.variant = "success";
    }

    if (status === ImportStatusEnum.Fail) {
      result.variant = "danger";
      result.text = `${this.$tc(this.$translate.Error)}`;
    }

    return result;
  }

  getImportType(type: ImportTypes) {
    if (type === ImportTypes.CourseV1JSON)
      return `${this.$tc(this.$translate.Course)}`;

    if (type === ImportTypes.CourseV2JSON)
      return `${this.$tc(this.$translate.Course)}`;

    if (type === ImportTypes.UserCSV)
      return `${this.$tc(this.$translate.Users)}`;

    if (type === ImportTypes.ContractorCSV)
      return `${this.$tc(this.$translate.Contractors)}`;

    if (type === ImportTypes.StudentCSV)
      return `${this.$tc(this.$translate.Students)}`;

    if (type === ImportTypes.LaborProtectionWorkerImport)
      return `${this.$tc(this.$translate.LaborProtectionWorker)}`;
    return `${this.$tc(this.$translate.Unknown)}`;
  }
}
